<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="productServiceForm" (ngSubmit)="onSave()">
            <h1 class="heading">
                {{productId ? 'Edit' : 'Add'}}
            </h1>

            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="grid gap-4 md:grid-cols-2 relative">

                <div class="space-y-1">
                    <label class="subheading">Company</label>
                    <div>
                        <select (change)="onCompanyChange()" [(ngModel)]="selectedCompany" id="Company"
                            [ngModelOptions]="{standalone: true}">
                            <option value="" disabled>Select company</option>
                            <option *ngFor="let item of companies" [value]="item.id">
                                {{ item.CompanyName | capitalize }}
                            </option>
                        </select>
                        <div *ngIf="submitted && !selectedCompany">
                            <p class="error text-red-600 text-xs mt-1">
                                Company is required
                            </p>
                        </div>
                    </div>

                </div>

                <!-- Name -->
                <div class="space-y-1">
                    <label class="subheading after:content-['*'] after:text-red-600">
                        Name
                    </label>
                    <input [readonly]="selectedCompany == ''" formControlName="Name" type="text" />
                    <div *ngIf="submitted && productServiceForm.get('Name')?.errors">
                        <p *ngIf="productServiceForm.get('Name')?.errors?.required"
                            class="error text-red-600 text-xs mt-1">
                            Name is required
                        </p>
                    </div>
                </div>



                <!-- Quantity on Hand -->
                <div class="space-y-1">
                    <label class="subheading">
                        Quantity on Hand <span class="text-red-600">*</span>
                    </label>
                    <input [readOnly]="selectedCompany == ''" formControlName="QtyOnHand" type="number" />
                </div>

                <!-- Unit Price -->
                <div class="space-y-1">
                    <label class="subheading">
                        Unit Price <span class="text-red-600">*</span>
                    </label>
                    <input [readOnly]="selectedCompany == ''" formControlName="UnitPrice" type="text" />
                </div>

                 <div class="space-y-1">
                    <label class="subheading">
                        Description
                    </label>
                    <input formControlName="Description" type="text" />
                </div>

                <ng-container formGroupName="reference" >
                
                <!-- reference -->
                <div class="space-y-1">
                    <div class="flex gap-2">

                        <div class="w-1/2">
                            <label class="subheading">
                                Ref ID
                            </label>
                            <div>
                                <div>
                                    <input formControlName="id" name="id" id="id" type="text" />
                                </div>
                            </div>
                        </div>

                        <div class="w-1/2">
                            <label class="subheading">
                                Ref Name
                            </label>
                            <div>
                                <div>
                                    <input formControlName="name" name="name" id="name" type="text" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="space-y-1">
                    <label class="subheading">
                        Priority
                    </label>
                    <input formControlName="priority" type="text" />
                </div>

                </ng-container>

                <!-- Type -->
                <div class="space-y-1">
                    <label class="subheading after:content-['*'] after:text-red-600">
                        Type
                    </label>
                    <ng-select [items]="ProductType | keyvalue" bindLabel="key" bindValue="value" formControlName="Type"
                        placeholder="Select Type">
                    </ng-select>
                </div>

                <!-- Income Account -->
                <div formGroupName="IncomeAccountRef" class="space-y-1">
                    <label class="subheading">Income Account</label>
                    <div>
                        <select formControlName="value" id="Id">
                            <option value="" disabled>Select Account</option>

                            <option *ngFor="let account of accountDetail" [value]="account.Id">
                                {{ account.Name | capitalize }}
                            </option>
                        </select>
                        <div *ngIf="submitted && incomeAccountRef.value.errors">
                            <p *ngIf="incomeAccountRef.value.errors?.required" class="error text-red-600 text-xs mt-1">
                                Value is required
                            </p>
                        </div>
                    </div>
                </div>

            </section>
            <section class="grid gap-4 sm:grid-cols-2 mt-3">
                <div class="space-y-1">
                    <label class="subheading">QB Status (Active/InActive)</label>
                    <div class="sm:col-span-2 flex items-center mt-6 space-x-2">
                        <label
                            class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <input type="checkbox" formControlName="Active" class="peer sr-only" (change)="toggleActive($event)"
                                aria-checked="productServiceForm.get('Active')?.value" />
                            <span
                                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                                <span *ngIf="!productServiceForm.get('Active')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                    aria-hidden="true">
                                    <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span *ngIf="productServiceForm.get('Active')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                        stroke="currentColor" class="h-3 w-3 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                    </svg>
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{productId ? 'Update' : 'Save'}}
                </button>
            </section>
        </form>
    </div>
</section>